import PropTypes from 'prop-types';
import React, { cloneElement } from 'react';

import { StyledForm } from './styles';

// pass disabled props to children to be able to disable the form
// does not support nested inputs
export const Form = ({ children, disabled }) => (
  <StyledForm>
    {React.Children.map(children, (child) =>
      // only clone and pass disabled props to form fields
      child?.props?.name
        ? cloneElement(child, {
            disabled,
            isDisabled: disabled,
            ...child.props,
          })
        : child,
    )}
  </StyledForm>
);

Form.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
};

Form.defaultProps = {
  children: undefined,
  disabled: false,
};
